module.exports = "<div class=\"msg-empty\">\n  <p class=\"msg-empty\" *ngIf=\"message\">{{message}}</p>\n</div>\n"